import React, { forwardRef, useEffect, useState } from "react";
import QRCode from "qrcode";
import "./qrcode.css";

const APP_TYPE = {
    // googlestore: "https://play.google.com/store/apps",
    // appstore: "https://apps.apple.com/apps",
    googlestore: "https://play.google.com/store/apps/details?id=com.hustem.g1cash&pli=1",
    appstore: "https://apps.apple.com/us/app/g1cash/id6459447318",
};

const Qrcode = forwardRef((props, ref) => {
    const { type } = props;
    const [dataUrl, setDataUrl] = useState();

    const generateQR = async (value) => {
        try {
            let url = await QRCode.toDataURL(value);
            setDataUrl(url);
        } catch (err) {
            // console.error(err);
        }
    };

    useEffect(() => {
        const link = APP_TYPE[type];
        generateQR(link);
    }, []);

    return (
        <>
            {dataUrl && (
                <div className="qr">
                    <img className="qr-image" src={dataUrl} alt={"qr code for join"} />
                </div>
            )}
        </>
    );
});

export default Qrcode;
